module.exports = __webpack_public_path__ + "img/stage.74dcb878.svg";